import React from 'react';
import NumberInput from './NumberInput';

interface ThresholdGroupProps {
  title?: string;
  description?: string;
  redValue: string;
  amberValue: string;
  greenValue: string;
  onRedChange: (value: string) => void;
  onAmberChange: (value: string) => void;
  onGreenChange: (value: string) => void;
  errors?: {
    red?: string;
    amber?: string;
    green?: string;
  };
  disabled?: boolean;
  isEditing?: boolean;
  prefixAriaLabel?: string;
}

export function ThresholdGroup({
  redValue,
  amberValue,
  greenValue,
  onRedChange,
  onAmberChange,
  onGreenChange,
  errors,
  disabled = false,
  isEditing = true,
  prefixAriaLabel = '',
}: ThresholdGroupProps) {
  const renderReadOnlyValue = (value: string) => (
    <div className="flex min-h-[38px] items-center justify-end rounded-lg border border-border bg-muted/40 px-2.5 py-2 text-[13px] text-foreground">
      {value || 'Not set'}
    </div>
  );

  return (
    <div className="grid gap-3 sm:grid-cols-3">
      <div>
        <span className="mb-1.5 block text-[13px] font-medium text-foreground">
          <span className="flex items-center gap-2">
            <span className="h-2 w-2 shrink-0 rounded-full bg-red-500"></span>
            Red below
          </span>
        </span>
        {isEditing ? (
          <NumberInput
            aria-label={`${prefixAriaLabel} Red below`}
            value={redValue}
            onChange={onRedChange}
            unit="%"
            placeholder="1"
            min={1}
            max={100}
            disabled={disabled}
            error={errors?.red}
          />
        ) : (
          renderReadOnlyValue(redValue)
        )}
      </div>

      <div>
        <span className="mb-1.5 block text-[13px] font-medium text-foreground">
          <span className="flex items-center gap-2">
            <span className="h-2 w-2 shrink-0 rounded-full bg-amber-500"></span>
            Amber below
          </span>
        </span>
        {isEditing ? (
          <NumberInput
            aria-label={`${prefixAriaLabel} Amber below`}
            value={amberValue}
            onChange={onAmberChange}
            unit="%"
            placeholder="1"
            min={1}
            max={100}
            disabled={disabled}
            error={errors?.amber}
          />
        ) : (
          renderReadOnlyValue(amberValue)
        )}
      </div>

      <div>
        <span className="mb-1.5 block text-[13px] font-medium text-foreground">
          <span className="flex items-center gap-2">
            <span className="h-2 w-2 shrink-0 rounded-full bg-emerald-500"></span>
            Green at/above
          </span>
        </span>
        {isEditing ? (
          <NumberInput
            aria-label={`${prefixAriaLabel} Green at/above`}
            value={greenValue}
            onChange={onGreenChange}
            unit="%"
            placeholder="1"
            min={1}
            max={100}
            disabled={disabled}
            error={errors?.green}
          />
        ) : (
          renderReadOnlyValue(greenValue)
        )}
      </div>
    </div>
  );
}

export default ThresholdGroup;


